<template>
  <div>
    <div class="homeVideo" v-if="$store.state.webNavigator=='pc'">
      <div v-if="videolist.length>0" class="home-video marginAuto max1720">
        <div class="flexSpace">
          <p class="part-title list-tlt displayIB">
            选择脂玫乐 他们已经收获美丽和自信
            <span class="list-tlt-tip">-</span></p>
          <div class="goto displayIB">
            <vue-link :to="{path:'/caseVideo/0-1-anlishipin.html'}"><img class="more-icon"
                                                                         :src="src1"
                                                                         alt=""></vue-link>
          </div>
        </div>
        <p class="col666666 home-tlt-fb">即刻加入他们，发现更好的自己！</p>
        <div class="flexSpace video-box">
          <div class="video-left home-video-big">
            <div
              v-for="(item , index) in videolist"
              v-if="index=='0'"
              :key="index"
              class="displayIB home-video-big pointEr"
              @click="playVideo(item.videoUrl,item.title)">
              <div class="positionRE">
                <img
                  :class="index=='0'?'homevideo-big-img':'homevideo-min-img'"
                  :src="myFun(item.coverImg)?myFun(item.coverImg):''"
                  :alt="item.title" title=""/>
                <img class="positionAB video-start" :class="index=='0'?'homevideo-big-start':'video-min-start'"
                     :src="index=='0'?src2:src3"
                     alt="" title=""/>
              </div>
              <div class="video-title col444444 firstText overflowText">{{item.title}}</div>
            </div>
          </div>
          <div class="video-right">
            <div
              v-for="(item , index) in videolist"
              :key="index"
              v-if="index=='1'||index=='2'"
              class="video-right-item home-video-min pointEr"
              @click="playVideo(item.videoUrl,item.title)">
              <div class="positionRE homevideo-min-box">
                <img
                  class="homevideo-min-img pointEr"
                  :src="myFun(item.coverImg)?myFun(item.coverImg):''"
                  :alt="item.title" title=""/>
                <img class="positionAB video-start video-min-start"
                     :src="src4"
                     alt="" title=""/>
              </div>
              <div class="video-title col444444 firstText overflowText">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="phone-page">
      <div v-if="videolist.length>0">
        <div class="PhoneHome-title">选择脂玫乐 <span class="col00CDA2">-</span> <br> 他们已经收获美丽和健康</div>
        <div class="PhoneVideo-ListBox">
          <div class="PhoneVideo-Box"
               v-for="(item , index) in videolist"
               :key="index"
               @click="playVideo(item.videoUrl,item.title)">
            <div class="PhoneVideo-imgBox positionRE">
              <img class="PhoneVideo-img" :src="httptype(item.coverImg)" :alt="item.title" title="">
              <div class="PhoneVideo-play positionAB"></div>
            </div>
            <p class="PhoneVideo-P">{{item.title}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';
import "../../../../plug/modifyImagePath"
import { myFun } from '../../../../plug/modifyImagePath';

export default {
  name: 'homeVideo',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      videolist: [],
      imgUrl: 'https://jusexcx.zmelo.com/',
      src1:myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/goto.png"),
      src2:myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/startbig.png"),
      src3:myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/startmin.png"),
      src4:myFun("https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/startmin.png"),
    };
  },
  methods: {
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
      return '';
    },
    myFun(a) {
        if(a instanceof Array){
            var array = [];
            a.map(item => {
                if(item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1){
                    var index = item.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
                    var items = item.substring(0, index) + "jusewebapp.zmelo.com" + item.substring(index + 39);
                    array.push(items)
                }else{
                    var index = item.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
                    item = item.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36);
                    array.push(items)
                }
            })
            return array;
        }else{
            if (a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com') != -1) {
                var index = a.indexOf('jusewebapp.oss-cn-hangzhou.aliyuncs.com');
                return a.substring(0, index) + "jusewebapp.zmelo.com" + a.substring(index + 39);
            }
            if (a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com') != -1) {
                var index = a.indexOf('jusexcx.oss-cn-hangzhou.aliyuncs.com');
                return a.substring(0, index) +  "jusexcx.zmelo.com" + a.substring(index + 36)
            }
        }
    },
    goMore () {
      this.$router.push({path: '/caseVideo/0/1/案例视频.html', });
    }, // 查看更多
    async getVideo () {
      let res = await $get(config.zmlgw + '/web/getVideoHomeList?code=A9&pageSize=3');// 视频列表接口1
      if (res.code == 200) {
        this.videolist = res.data;
      }
    },
    playVideo (url, tlt) {
      this.$emit('playVideo', url, tlt);
    },
  },
  mounted () {
    this.getVideo();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');

  @media screen and (max-width: 800px) {
    .phone-page {
      padding: 70*@width1 0 0;
      background: #fff;
    }

    .PhoneVideo-ListBox {
      margin-top: 43*@width1;
    }

    .PhoneVideo-Box {
      width: 690*@width1;
      margin-bottom: 38*@width1;
    }

    .PhoneVideo-imgBox, .PhoneVideo-img {
      width: 690*@width1;
      height: 388*@width1;
    }

    .PhoneVideo-P {
      margin-top: 21*@width1;
      font-size: 28*@width1;
      color: #333333;
      line-height: 40*@width1;
    }

    .PhoneVideo-play {
      background: url(https://jusewebapp.zmelo.com/zml-gw/v1.1.1/phone/phonePlay.png) no-repeat;
      background-size: cover;
      width: 88*@width1;
      height: 88*@width1;
      left: 50%;
      top: 45%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

  }

  @media screen and (min-width: 800px) {
    .video-right {
      height: 272.5*@width;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    .video-box {
      align-items: flex-start;
      padding-bottom: 44*@width;
    }

    .home-video-big, .homevideo-big-img {
      width: 484*@width;
    }

    .home-video {
      width: 700*@width;
    }

    .home-video-min:hover .overflowText {
      color: #00D2A6;
    }

    .video-title {
      font-size: 8*@width;
      color: #444;
      margin-top: 9*@width;
      line-height: 10*@width;
    }

    .homevideo-big-img {
      height: 272.5*@width;
    }

    .home-video-min, .homevideo-min-box {
      width: 196*@width;
    }

    .home-video-min:first-of-type {
      margin-bottom: 31*@width;
    }

    .homevideo-min-box {
      margin-bottom: 9*@width;
    }

    .homevideo-min-img {
      width: 196*@width;
      height: 110*@width;
    }

    .homevideo-big-start {
      width: 75*@width;
      height: 75*@width;
    }

    .video-min-start {
      width: 75*@width/2;
      height: 75*@width/2;
    }

    .video-start {
      left: 50%;
      top: 45%;
      transform: translate(-50%, -50%);
    }

    .home-doctorvideo {
      padding: 0 50*@width;
    }

    .video-right-item {
    }
  }
</style>



// WEBPACK FOOTER //
// homeVideo.vue